import { CustomImage, Modal, ProgressIndicator, Scrollbar, TextBox, Tooltip } from "@veneer/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import '../../../assets/css/components/activities/visualInventory.css'
import { IMaterialVisualInventoryDto } from "../../../models/dto/agendaApi/IMaterialVisualInventoryDto";
import { VisualCategoryEnum } from "../../../models/enum/VisualCategoryEnum";
import ImageService from "../../../services/generalApi/image.service";
import { NumberFormatBase } from 'react-number-format';

const VisualInventory = (props: any) => {
    const [t] = useTranslation("global");
    const [materialVisualInventory, setMaterialVisualInventory] = useState<IMaterialVisualInventoryDto[]>(props.materialVisualInventory);
    const [open, setOpen] = useState(false);
    const [modalUrl, setModalUrl] = useState('');
    const [materialName, setMaterialName] = useState('');
    const [blobImages, setBlobImages] = useState<any[]>([]);
    const [imagesLoaded, setImagesLoaded] = useState(false);
    const arrayPromises: any[] = [];

    useEffect(() => {
        if (props.materialVisualInventory) {
            setMaterialVisualInventory(props.materialVisualInventory);
        }
    }, [props.materialVisualInventory])

    const saveAnswer = (quantity: number, materialTypeId: number, categoryId: number, classificationType: number) => {
        props.onSetValue(quantity, materialTypeId, categoryId, classificationType);
    }

    const showImage = (url: string, materialName: string) => {
        setOpen(true);
        setModalUrl(url);
        setMaterialName(materialName);
    }

    useEffect(() => {
        materialVisualInventory.forEach(x => {
            let promise = ImageService.getBlobImage(x.imageUrl)
                .then((r: any) => {
                    let url = URL.createObjectURL(r);
                    return { id: x.materialId, url };
                });
            arrayPromises.push(promise)
        });
        Promise.all(arrayPromises)
            .then((r) => {
                setBlobImages(r);
                setImagesLoaded(true);
            })
            .catch((error: any) => {
                console.error(error);
            });
    }, [materialVisualInventory]);

    const getUrlFromBlob = (materialId: number) => {
        let material = blobImages.find(x => x.id == materialId)
        if (material)
            return material.url;
        return "";
    }

    return (
        <div>
            <table className="tableVei">
                <thead className="theadVei">
                    <tr className="trVei">
                        <th className="thVei"></th>
                        <th className="thVei">{t('header.material')}</th>
                        <th className="thVei">{t('header.computers')}</th>
                        <th className="thVei">{t('header.printers')}</th>
                        <th className="thVei">{t('header.supplies')}</th>
                    </tr>
                </thead>
                <tbody className="tbodyVei">
                    {
                        materialVisualInventory.map((m: IMaterialVisualInventoryDto) => {
                            return (
                                <tr className="trVei" key={m.materialId.toString()}>
                                    <td className="tdVei" style={{ width: '10%' }}>
                                        <div >
                                            <div >
                                                {
                                                    imagesLoaded ? <Tooltip
                                                        content={<>{t("modal.maximize")}</>}
                                                        id="tooltip"
                                                        placement="bottom">
                                                        <CustomImage size={48} quietArea={0} width={30} height={30}
                                                            src={getUrlFromBlob(m.materialId)} onClick={() => showImage(getUrlFromBlob(m.materialId), m.materialName)}
                                                            style={{ cursor: 'pointer' }} />
                                                    </Tooltip> : <ProgressIndicator
                                                        appearance="circular"
                                                        behavior="indeterminate"
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{ width: '30%' }} className="alignLeftVei tdVei">{m.materialName}</td>
                                    <td style={{ width: '20%', padding: '1%' }} className="alignCenterVei tdVei"><TextBox className="textFieldNumberVei" css={{ textAlign: 'right' }} inputComponent={NumberFormatBase} maxLength={3} onBlur={(e) => saveAnswer(Number(e.target.value), m.materialId, VisualCategoryEnum.PcNotebooks, m.classificationType)} /></td>
                                    <td style={{ width: '20%', padding: '1%' }} className="alignCenterVei tdVei"><TextBox className="textFieldNumberVei" css={{ textAlign: 'right' }} inputComponent={NumberFormatBase} maxLength={3} onBlur={(e) => saveAnswer(Number(e.target.value), m.materialId, VisualCategoryEnum.Print, m.classificationType)} /></td>
                                    <td style={{ width: '20%', padding: '1%' }} className="alignCenterVei tdVei"><TextBox className="textFieldNumberVei" css={{ textAlign: 'right' }} inputComponent={NumberFormatBase} maxLength={3} onBlur={(e) => saveAnswer(Number(e.target.value), m.materialId, VisualCategoryEnum.Supplies, m.classificationType)} /></td>
                                </tr>
                            )
                        }
                        )
                    }
                </tbody>
            </table>
            <Modal
                align="center"
                id="modal-id"
                show={open}
                onClose={() => setOpen(false)}
                closeButton
                title={materialName}
            >
                <div style={{ textAlign: 'center' }}>
                    <CustomImage size={300} quietArea={0} src={modalUrl} />
                </div>
            </Modal>
        </div >
    );
}

export default VisualInventory;